import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import IAQDownloadSensorForm from './components/IAQDownloadSensorForm';
import * as actions from '../../core/actions/actions';
import { reset } from 'redux-form';
import URLConstants from '../../core/constants/url.constants';
import { allBuildingsSelector } from '../../core/selectors/sensor.selector';
import IState from '../../core/models/IState';
import { toast } from 'react-toastify';
import { formatMessage } from '../../translations/connectedIntlProvider';
import { getUserTypeFromLocalStorage } from '../../helpers/local.storage.helpers';
import { getTZOffset } from '../../constants/common.constant';

const IAQSensordataDownloadSensor = (props: any) => {
  const dispatch = useDispatch();
  const { filePreparation }: any = useSelector((state: IState) => { return state.file });
  const { userType, userId }: any = useSelector((state: IState) => { return state.auth });
  const buidlingList = useSelector(allBuildingsSelector);

  useEffect(() => {
    dispatch(actions.getUniqueBuilding());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  const onSubmitForm = (values: any) => {
    let downloadURL = URLConstants.DownloadDecodedIAQDataByID;
    let donwloadObj = {
      Model: props.model,
      ICCID: props.id,
      StartDate: values.StartDate+" 00:00:00",
      EndDate: values.EndDate+" 23:59:59",
      DateType: values.DateType,
      Prefix: values.Prefix,
      UserId: userId,
      IsAdmin: getUserTypeFromLocalStorage() === 'Administrator',
      TZOffset: getTZOffset() // Timestamp offset sent for conversion of date time UTC to local
    }
    // downloadCsvPost(downloadURL, donwloadObj);
    dispatch(actions.filePreparation(downloadURL, donwloadObj));
  }

  useEffect(() => {
    if (filePreparation.success) {
      toast.success(formatMessage("File_Preparation_Started"));
      dispatch(actions.resetfilePreparationState());
      onModalClosed();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filePreparation.success]);
  
  useEffect(() => {
    if (filePreparation.error != null) {
      toast.error(formatMessage(filePreparation.error));
      dispatch(actions.resetfilePreparationState());
      onModalClosed();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filePreparation.error]);

  const onModalClosed = () => {
    dispatch(reset('DownloadSensorForm'));
    props.modalClosed();
  }

  return (
    <React.Fragment>
      <IAQDownloadSensorForm
        id={props.id}
        submitHandler={onSubmitForm}
        onModalClosed={onModalClosed}
        buidlingList={buidlingList}
        isLoading={filePreparation.loading}
      />
    </React.Fragment>
  );
};

export default IAQSensordataDownloadSensor;
